import {capitaliseFirst, you} from "./__strings"
import PropTypes from "prop-types";

export default function income(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    let questions = [
        grossBasic(betterProps),
    ]
    //TODO: Add Question, If self-employed, What is main source of income Salary or Drawings/Director Remuneration,
    let app = 'applicant'+props.applicant
    if (props.mortgage[app].employment.employmentType==="SELFEMPLOYED"){
        questions.push(selfIncomeSource(betterProps))
    }
    //TODO: Add Question, Name of Institution in which income/salary is paid
    if (props.mortgage[app].employment.employmentType==="EMPLOYED"){
        questions.push(salariedInstitution(betterProps))
    }
    questions = [
        ...questions,
        incomeChecks(betterProps),
        overtime(betterProps),
        bonus(betterProps),
        commission(betterProps),
        //TODO: Add Question, maintenance payments amount per year?
        maintenance(betterProps),
        //TODO: Add Question, Do you receive any social welfare payments?
        welfare(betterProps),
        //TODO: Add Question, Do you have a 2nd Job??
        secondjob(betterProps),
        rentalIncome(betterProps),
        dividends(betterProps),
        investments(betterProps),
        other(betterProps),
        otherSourceDetails(betterProps),

        // hasOvertime(betterProps),
        // hasBonus(betterProps),
        // hasCommission(betterProps),
        // hasOther(betterProps),
        // otherSource(betterProps),

        nonEuroCurrency(betterProps),
        irishTaxResident(betterProps),
        ppsNumber(betterProps),
        usCitizen(betterProps),
        usaTaxId(betterProps),
        otherTaxResident(betterProps),
        otherTaxCountry(betterProps),
        otherTaxId(betterProps)
    ]

    return {
        name: `income-${props.applicant}`,
        title: 'Income & tax details',
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' income & tax details',
        link: `apply-${props.applicant}/income`,
        props: props,
        questions: questions
    }
}
export function incomeChecks(props){
    return {
        label: "Income Types",
        text: "Which of the follow types of income "+ (props.you.doYou) + " receive?",
        name: "incomeChecks",
        answer: {
            type: "multichoice",
            optional: true,
            choices: [
                {
                    value: "OVERTIME",
                    text: "Overtime"
                }, {
                    value: "BONUS",
                    text: "Bonus"
                }, {
                    value: "COMMISSION",
                    text: "Commission"
                }, {
                    value: "MAINTENANCE",
                    text: "Maintenance"
                },{
                    value: "WELFARE",
                    text: "Social Welfare"
                }, {
                    value: "SECONDJOB",
                    text: "2nd Job"
                }, {
                    value: "RENT",
                    text: "Rental Income"
                }, {
                    value: "DIVIDENDS",
                    text: "Dividends"
                }, {
                    value: "INVESTMENTS",
                    text: "Investments"
                }, {
                    value: "OTHER",
                    text: "Other Income"
                }
            ]
        },
        model: "income"
    }

}
export function grossBasic(props) {
    return {
        name: "grossBasic",
        label: "Gross Basic",
        text: "What is " + props.you.your + " gross basic salary?",
        answer: {
            type: "euro",
            validation: {
                min: {value: 5000, message: "This must be a value greater than €5,000"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        model: "income"

    }
}
export function salariedInstitution(props) {
    return {
        label: "Institution for Salary",
        text: "Name of bank or institution in which income/salary is paid",
        name: "salariedInstitution",
        answer: {
            type: "text"
        },
        model: "income"
    }
}
export function selfIncomeSource(props) {
    return {
        label: "Main Income Source",
        text: "What is main source of "+ props.you.your +" income?",
        name: "selfIncomeSource",
        answer: {
            type: "choice",
            choices: [
                {
                    value: "SALARY",
                    text: "Salary"
                }, {
                    value: "DRAWINGS",
                    text: "Drawings/Director Remuneration"
                }
            ]
        },
        model: "income"
    }

}
export function hasOvertime(props) {
    return {
        label: "Overtime Earned",
        text: capitaliseFirst(props.you.doYou) + " earn overtime pay?",
        name: "hasOvertime",
        answer: {
            type: "choice",
            choices: [
                {
                    value: true,
                    text: "Yes"
                }, {
                    value: false,
                    text: "No"
                }
            ]
        },
        model: "income"
    }
}
export function overtime(props) {
    return {
        label: "Overtime Amount",
        text: "How much over-time pay " + props.you.doYou + " earn in a year?",
        name: "overtime",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 1000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('OVERTIME')
            }
        },
        model: "income"
    }
}
export function hasBonus(props) {
    return {
        label: "Bonus Earned",
        text: capitaliseFirst(props.you.doYou) + " receive a bonus?",
        name: "hasBonus",
        answer: {
            type: "choice",
            choices: [{
                value: true,
                text: "Yes"
            }, {
                value: false,
                text: "No"
            }]
        },
        model: "income"
    }
}
export function bonus(props) {
    return {
        label: "Bonus Amount",
        text: "How much bonus " + props.you.doYou + " receive in a year?",
        name: "bonus",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('BONUS')
            }
        },
        model: "income"
    }
}
export function hasCommission(props) {
    return {
        label: "Commission Earned",
        text: capitaliseFirst(props.you.doYou) + " receive commission?",
        name: "hasCommission",
        answer: {
            type: "choice",
            choices: [{
                value: true,
                text: "Yes"
            }, {
                value: false,
                text: "No"
            }]
        },
        model: "income"
    }
}
export function commission(props) {
    return {
        label: "Commission Amount",
        text: "How much commission " + props.you.doYou + " receive in a year?",
        name: "commission",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('COMMISSION')
            }
        },
        model: "income"
    }
}
export function hasOther(props) {
    return {
        label: "Other Income Earned",
        text: capitaliseFirst(props.you.doYou) + " receive any other income throughout the year?",
        name: "hasOther",
        answer: {
            type: "choice",
            choices: [
                {
                    value: true,
                    text: "Yes"
                }, {
                    value: false,
                    text: "No"
                }
            ]
        },
        model: "income"
    }
}
export function maintenance(props) {
    return {
        label: "Maintenance Amount",
        text: "How much maintenance " + props.you.doYou + " receive in a year?",
        name: "maintenance",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('MAINTENANCE')
            }
        },
        model: "income"
    }
}
export function welfare(props) {
    return {
        label: "Social Welfare Amount",
        text: "How much social welfare " + props.you.doYou + " receive in a year?",
        name: "welfare",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('WELFARE')
            }
        },
        model: "income"
    }
}
export function secondjob(props) {
    return {
        label: "Second Job",
        text: "How much " + props.you.doYou + " receive (before tax) from the second job in a year?",
        name: "secondjob",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('SECONDJOB')
            }
        },
        model: "income"
    }
}
export function rentalIncome(props) {
    return {
        label: "Social Welfare Amount",
        text: "How much " + props.you.doYou + " receive from all rentals in a year?",
        name: "rentalIncome",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('RENT')
            }
        },
        model: "income"
    }
}
export function dividends(props) {
    return {
        label: "Dividends Amount",
        text: "How much " + props.you.doYou + " receive from all dividends in a year?",
        name: "dividends",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('DIVIDENDS')
            }
        },
        model: "income"
    }
}
export function investments(props) {
    return {
        label: "Investments Amount",
        text: "How much " + props.you.doYou + " receive from all investments in a year?",
        name: "investments",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('INVESTMENTS')
            }
        },
        model: "income"
    }
}
export function other(props) {
    return {
        label: "Other Income Amount",
        text: "How much " + props.you.doYou + " receive in a year from this?",
        name: "other",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('OTHER')
            }
        },
        model: "income"
    }
}
export function otherSourceDetails(props) {
    return {
        label: "Other Income Details",
        text: "Supply details from where this income comes",
        name: "otherSourceDetails",
        answer: {
            type: "text"
        },
        hides: {
            incomeChecks: (v) => {
                return !v || !v.includes('OTHER')
            }
        },
        model: "income"
    }
}
export function otherSource(props) {
    return {
        label: "Other Income Source",
        text: "From where does this income come?",
        name: "otherSource",
        answer: {
            type: "choice",
            "choices": [
                {
                    text: "Rent",
                    value: "RENT"
                },
                {
                    text: "Dividends",
                    value: "DIVIDENDS"
                },
                {
                    text: "Investment",
                    value: "INVESTMENTS"
                },
                {
                    text: "Other",
                    value: "OTHER"
                },
            ]
        },
        hides: {
            hasOther: (v) => {
                return v !== true
            }
        },
        model: "income"
    }
}

export function nonEuroCurrency(props) {
    return {
        label: "Non Euro Earned",
        text: capitaliseFirst(props.you.doYou) + " receive any income in a non-euro currency?",
        name: "nonEuroCurrency",
        answer: {
            type: "choice",
            choices: [{
                value: true,
                text: "Yes"
            }, {
                value: false,
                text: "No"
            }]
        },
        model: "income"
    }
}

export function irishTaxResident(props) {
    return {
        label: "Irish Tax Resident",
        text: capitaliseFirst(props.you.areYou) + " a tax resident of Ireland?",
        name: "irishTaxResident",
        answer: {
            type: "choice",
            choices: [{
                value: true,
                text: "Yes"
            }, {
                value: false,
                text: "No"
            }]
        },
        model: "tax"
    }
}
export function ppsNumber(props) {
    return {
        label: "PPS Number",
        text: "What is " + props.you.your + " PPS Number?",
        name: "ppsNumber",
        answer: {
            type: "text",
            validation: (v) => {
                return /^\d{7}[a-zA-Z]{1,2}$/.test(v) ? false : "Please enter a valid PPS Number"
            },
            style: {textTransform:'uppercase'}
        },
        hides:{
            irishTaxResident:(v)=>{return v!==true }
        },
        model: "tax"
    }
}
export function usCitizen(props) {
    return {
        label: "US Citizen",
        text: capitaliseFirst(props.you.areYou) + " a citizen of the USA?",
        name: "usCitizen",
        answer: {
            type: "choice",
            choices: [{
                value: true,
                text: "Yes"
            }, {
                value: false,
                text: "No"
            }]
        },
        model: "tax"
    }
}
export function usaTaxId(props) {
    return {
        label: "USA Tax ID",
        text: "What is " + props.you.your + " USA tax payer identification number",
        name: "usaTaxId",
        answer: {
            type: "text"
        },
        hides: {
            usCitizen: (v) => {
                return v !== true
            }
        },
        model: "tax"
    }
}
export function otherTaxResident(props) {
    return {
        label: "Foreign Tax Resident",
        text: capitaliseFirst(props.you.areYou) + " a tax resident of any other country?",
        name: "otherTaxResident",
        answer: {
            type: "choice",
            choices: [
                {
                    value: true,
                    text: "Yes"
                }, {
                    value: false,
                    text: "No"
                }
            ]
        },
        model: "tax"
    }
}
export function otherTaxCountry(props) {
    return {
        label: "Foreign Tax Country",
        text: "What country is that?",
        name: "otherTaxCountry",
        answer: {
            type: "country"
        },
        hides: {
            otherTaxResident: (v) => {
                return v !== true
            }
        },
        model: "tax"
    }
}
export function otherTaxId(props) {
    return {
        label: "Foreign Tax ID",
        text: "What is " + props.you.your + " foreign tax payer identification number",
        name: "otherTaxId",
        answer: {
            type: "text"
        },
        hides: {
            otherTaxResident: (v) => {
                return v !== true
            }
        },
        model: "tax"
    }
}
income.propTypes = {
    applicant: PropTypes.number
};
